import { render, staticRenderFns } from "./ccpage.vue?vue&type=template&id=0c219638&scoped=true&"
import script from "./ccpage.vue?vue&type=script&lang=js&"
export * from "./ccpage.vue?vue&type=script&lang=js&"
import style0 from "./ccpage.vue?vue&type=style&index=0&id=0c219638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c219638",
  null
  
)

export default component.exports